// istanbul ignore file: doesn't hold any logic
"use strict";

exports.defaultOptions = {
  productionOnly: true
};
